import { createApp } from 'vue'
import ElementPlus, { ElMessage } from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/styles/index.scss'
import App from './App.vue'
import router from './router'
import pinia from './stores'
import i18n from './locales'
import CommonComponents from './components/index'
import { useAuthStore } from '@/stores/auth'
import { configureAuthButtonChecker } from '@/hooks/useAuthButtons'
import { AUTH_SESSION_EXPIRED_EVENT } from '@/utils/authSession'

const app = createApp(App)

configureAuthButtonChecker(permission => {
  const permissions = useAuthStore(pinia).currentUser?.permissions || []
  return permissions.includes('*') || permissions.includes(permission)
})

for (const [name, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(name, component)
}

app.use(pinia).use(router).use(i18n).use(ElementPlus).use(CommonComponents).mount('#app')

window.addEventListener(AUTH_SESSION_EXPIRED_EVENT, () => {
  const authStore = useAuthStore(pinia)
  if (!authStore.isAuthenticated) return

  authStore.clearSession()
  ElMessage.warning('登录已失效，请重新登录')
  if (router.currentRoute.value.name !== 'login') {
    void router.replace({ name: 'login' })
  }
})
